import { ChangeDetectorRef, Injectable } from '@angular/core';

import { Collection } from './collection.model';
import { IFBCollectionService } from '@app/models/collection';
import { NgOnDestroy } from '@app/shared/services/ng-on-destroy.service';

@Injectable()
export class CollectionService {
  constructor() {}

  collection<Item, Counts>(
    service: IFBCollectionService<Item>,
    destroy: NgOnDestroy,
    resources?: any,
    cdr?: ChangeDetectorRef
  ): Collection<Item, Counts> {
    return new Collection<Item, Counts>(service, destroy, resources, cdr);
  }
}
